export const IF_PERSON_ALREADY_VISITED = "if_person_already_visited";
export const CURRENT_WORKSPACE_ID = "current_workspace_id";
export const AUTH_REDIRECT_URL = "auth_redirect_url_1";
export const DEAL_FILTER_OWNER_ID = "deal_filter_owner";
export const DEAL_FILTER_DATE_RANGE_ID = "deal_filter_date_range";
export const PENDING_SLACK_INSTALL_ID = "pending_slack_install_id";


export const isBrowser = typeof window !== "undefined";
